/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it include the end date?`)
};

const es_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Incluye la fecha final?`)
};

const de_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includes es das Enddatum?`)
};

const nl_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt de einddatum meegeteld?`)
};

const fr_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclut-il la date de fin?`)
};

const it_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include la data di fine?`)
};

const pt_br2_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclui a data final?`)
};

const pt_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclui a data de fim?`)
};

const ja_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了日は含まれていますか？`)
};

const zh_dd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否包含结束日期？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq2_q", locale)
	if (locale === "en") return en_dd_faq2_q(inputs)
	if (locale === "es") return es_dd_faq2_q(inputs)
	if (locale === "de") return de_dd_faq2_q(inputs)
	if (locale === "nl") return nl_dd_faq2_q(inputs)
	if (locale === "fr") return fr_dd_faq2_q(inputs)
	if (locale === "it") return it_dd_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq2_q(inputs)
	if (locale === "pt") return pt_dd_faq2_q(inputs)
	if (locale === "ja") return ja_dd_faq2_q(inputs)
	return zh_dd_faq2_q(inputs)
};